/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ColorBlindProtanopia(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ColorBlindProtanopia',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M8.467 10.48a5.5 5.5 0 0 1-5.468-3.19A4.001 4.001 0 0 0 4.5 15a4 4 0 0 0 3.967-4.52","fill":"#2FC862"}),createElement('path', {"d":"M7.5 11q0-.264.033-.52a5.5 5.5 0 0 0 5.468-3.19A4.001 4.001 0 0 1 11.5 15a4 4 0 0 1-4-4","fill":"#2496FF"}),createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M8 7.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2M8 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8","fill":"#FF424D"}))
}
